// extracted by mini-css-extract-plugin
export default {"ageSelector":"AgeSelector_ageSelector__qREDz","list":"AgeSelector_list__EPZvD"};